import { TableButton } from '@ipfabric/ui-components/TableButton/TableButton';
import { createDateTimeColumn, createTextColumn } from '@ipfabric/utils';
import { isReservedLabelName } from '@ipfabric/utils/labels';
import { createFrontendOnlyColumn } from 'components/Table/columns/frontendOnlyColumn';
import type { EditableLabel, LabelCatalogEntry } from './labelCatalogApi';

type LabelsTableColumnHandlers = {
  onDelete: (id: string, name: string) => void;
  onEdit: (label: EditableLabel) => void;
};

export const createLabelsTableColumns = ({
  onDelete,
  onEdit,
}: LabelsTableColumnHandlers) => [
  createTextColumn<LabelCatalogEntry>({
    key: 'id',
    title: 'ID',
    hidden: true,
  }),
  createTextColumn<LabelCatalogEntry>({
    key: 'name',
    title: 'Labels',
  }),
  createTextColumn<LabelCatalogEntry>({
    key: 'values',
    title: 'Possible values',
    array: true,
  }),
  createDateTimeColumn<LabelCatalogEntry>({
    key: 'changedAt',
    title: 'Last change',
    format: 'dateFormat',
  }),
  createTextColumn<LabelCatalogEntry>({
    key: 'changedBy',
    title: 'Changed by',
  }),
  createFrontendOnlyColumn<LabelCatalogEntry>({
    key: 'actions',
    title: 'Actions',
    disabledSort: true,
    webDependencies: ['id', 'name', 'values'],
    render: (row) => (
      <div className='flex flex-row items-center gap-xs'>
        <TableButton
          dataTestId={`labels-list-${row.name}-edit-icon`}
          variant='plain'
          icon='fa-pen'
          size='default'
          onClick={() =>
            onEdit({
              id: row.id,
              name: row.name,
              values: row.values,
            })
          }
          type='button'
        />
        <TableButton
          dataTestId={`labels-list-${row.name}-remove-icon`}
          disabled={isReservedLabelName(row.name)}
          variant='plain'
          accent='negative'
          icon='fa-trash-can'
          size='default'
          onClick={() => onDelete(row.id, row.name)}
          type='button'
        />
      </div>
    ),
  }),
];
